<template>
  <sys-user-table
    client-type="admin"
    title="Admin List"
    create-text="New Admin"
    entity-name="admin"
    show-roles
    protect-built-in-admin
  />
</template>

<script>
import SysUserTable from '@/views/system/components/SysUserTable.vue'

export default {
  name: 'SystemAdminList',
  components: { SysUserTable }
}
</script>
